export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR';

export const ADD_MULTIPLE_TO_CART_REQUEST = 'ADD_MULTIPLE_TO_CART_REQUEST';
export const ADD_MULTIPLE_TO_CART_SUCCESS = 'ADD_MULTIPLE_TO_CART_SUCCESS';
export const ADD_MULTIPLE_TO_CART_ERROR = 'ADD_MULTIPLE_TO_CART_ERROR';

export const CART_ITEM_OUT_OF_STOCK = 'CART_ITEM_OUT_OF_STOCK';
export const NO_SIZE_SELECTED_ERROR = 'NO_SIZE_SELECTED_ERROR';

export const ADD_TO_CART_GENERIC_ERROR = 'ADD_TO_CART_GENERIC_ERROR';
export const ADD_TO_CART_IDENTITY_GENERIC_ERROR = 'ADD_TO_CART_IDENTITY_GENERIC_ERROR';
